export const format = (format, ...args) => {
  return format.replace(/{(\d+)}/g, (match, number) => { 
    return typeof args[number] != 'undefined'
      ? args[number] 
      : match
    ;
  });
};

export const getInitials = (name) => {
  name = name || '';
  return name.split(' ')
    .map(i => i.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('');
};

export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.substr(1);
};
